module.exports = __webpack_public_path__ + "img/teams.a4761bc6.svg";